import EndNode from "@/components/flow/designer/node/EndNode.vue";
import StartNode from "@/components/flow/designer/node/StartNode.vue";
import ParallelNode from "@/components/flow/designer/node/ParallelNode.vue";
import ParallelWrapNode from "@/components/flow/designer/node/ParallelWrapNode.vue";
import CheckNode from "@/components/flow/designer/node/CheckNode.vue";
import JudgeWrapNode from "@/components/flow/designer/node/JudgeWrapNode.vue";
import JudgeNode from "@/components/flow/designer/node/JudgeNode.vue";
import CCNode from "@/components/flow/designer/node/CCNode.vue";
import TriggerNode from "@/components/flow/designer/node/TriggerNode.vue";
import DelayNode from "@/components/flow/designer/node/DelayNode.vue";


export default {
    EndNode,
    StartNode,
    ParallelNode,
    ParallelWrapNode,
    CheckNode,
    JudgeNode,
    JudgeWrapNode,
    CCNode,
    TriggerNode,
    DelayNode
}
